export function create2dArray(width, height, value) {
    if (value instanceof Function) {
        return Array(width).fill(0).map((_, x) => Array(height).fill(x).map(value));
    }
    else {
        return Array(width).fill(0).map(_ => Array(height).fill(value));
    }
}
